/**
 * The components ListGrid and List/Detail screens use by tag without importing them. Every Vue entry
 * (customer app.js, Sophia main.js) registers them here, so a new one reaches both.
 */
export function registerListKit(Vue) {
  Vue.component('AgGridFilterPanel', () => import('../ag-grid/AgGridFilterPanel.vue'));
  Vue.component('AgGridSaveViewModal', () => import('../ag-grid/AgGridSaveViewModal.vue'));
  Vue.component('AgGridViewChooser', () => import('../ag-grid/AgGridViewChooser.vue'));
  Vue.component('AgGridColumnChooser', () => import('../ag-grid/AgGridColumnChooser.vue'));
  Vue.component('ListDetailPage', () => import('./ListDetailPage.vue'));
}
